module.exports = __webpack_public_path__ + "img/img-thaihilo-s.a6db3ef8.png";